import * as React from 'react';
import { SVGProps } from 'react';

const IconWifiWarningSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 3a1 1 0 1 1 2 0v12a1 1 0 1 1-2 0V3ZM9 4.297a15.27 15.27 0 0 0-2.976.92A15.555 15.555 0 0 0 1 8.658s1.515 1.615 1.692 1.797A13.032 13.032 0 0 1 9 6.85V4.297ZM9 10.479a9.695 9.695 0 0 0-3.899 2.45l1.721 1.768A7.314 7.314 0 0 1 9 13.154v-2.675ZM15 13.167v-2.678a9.697 9.697 0 0 1 3.87 2.44l-1.722 1.768A7.316 7.316 0 0 0 15 13.167ZM21.279 10.454A13.034 13.034 0 0 0 15 6.857V4.302c1.007.204 1.994.51 2.946.916A15.557 15.557 0 0 1 23 8.686l-1.721 1.768ZM12 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
  </svg>
);
export default IconWifiWarningSizeM;
